module.exports = (a, b) => ((a.sort_num || 1000) - (b.sort_num || 1000))